var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('chart-filter',{attrs:{"chart-id":_vm.filterForm.chart_id},on:{"change":_vm.onChange}}),_c('br'),_c('ai-ticket-info',{attrs:{"filter-form":_vm.filterForm,"height":"360px"}}),_c('br'),_c('ai-quality',{attrs:{"filter-form":_vm.filterForm,"height":"360px"}}),_c('br')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }